import React from 'react';
import ReactDOM from 'react-dom';
import MainComponent from './main-component.js';
import { BrowserRouter } from 'react-router-dom';
import './style/core.scss';
import { initAuth } from 'data/auth';

const rootElement = document.getElementById('root');
initAuth().then(() => {
  ReactDOM.render(
    <BrowserRouter>
      <MainComponent />
    </BrowserRouter>,
    rootElement
  );
});
